import { Crown } from "lucide-react";
import { Link } from "react-router-dom";

export default function SubscriptionUpgradeComponent() {
  return (
    <p className="flex items-center gap-2 mt-6 py-1 px-2 border-amber-300 border bg-orange-100 rounded-xl">
      <Crown style={{ width: 16 }} className="text-red-500" />
      <p className="text-xs text-red-500">
        Please upgrade your{" "}
        <Link to={"/subscriptions"} className="underline">
          subscription
        </Link>
      </p>
    </p>
  );
}
